import _objectSpread from "@babel/runtime/helpers/objectSpread2";
/**
 * This link adds a crehana-current-url header in each xhr request
 * to know where are coming from the queries and mutations
 */
import { ApolloLink } from '@apollo/client';
var crehanaCurrentUrl = typeof window === 'undefined' ? '' : /*#__PURE__*/"".concat(window.location.pathname).concat(window.location.search);
var crehanaCurrentUrlLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  operation.setContext(function (_ref) {
    var _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        'crehana-current-url': crehanaCurrentUrl
      })
    };
  });
  return forward(operation);
});
export default crehanaCurrentUrlLink;